import { render } from "./ProviderTab.vue?vue&type=template&id=7b71e0b4"
import script from "./ProviderTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/notification/components/form/ProviderTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b71e0b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b71e0b4', __exports__)) {
    api.reload('7b71e0b4', __exports__)
  }
  
  module.hot.accept("./ProviderTab.vue?vue&type=template&id=7b71e0b4", () => {
    api.rerender('7b71e0b4', render)
  })

}


export default __exports__